var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPHeatingOutDoorHeatPumpSw = function SvgPHeatingOutDoorHeatPumpSw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "626.1,134.5 626.1,62.1 638.1,62.1 638.1,139.1",
    fill: "#FFFFFF"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "631.1,136.1 631.1,62.1 633.1,62.1 633.1,136.8",
    fill: "#DF1400"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "629.1,135.7 629.1,62.1 628.1,62.1 628.1,135.3",
    fill: "#787878"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "635.1,139.7 635.1,62.1 636.1,62.1 636.1,140.1",
    fill: "#787878"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "626.1,130.1 572.1,130.1 572.1,142.1 626.1,142.1 631.1,137.1 631.1,135.1",
    fill: "#FFFFFF"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "633.1,135.1 572.1,135.1 572.1,137.1 633.1,137.1",
    fill: "#DF1400"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "629.1,133.1 572.1,133.1 572.1,132.1 629,132.1",
    fill: "#787878"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 572.1,
    y: 139.1,
    width: 64,
    height: 1,
    fill: "#787878"
  })));
};
export default SvgPHeatingOutDoorHeatPumpSw;